// TODO: endpoint updated to use StudlyCaps

export enum TransactionStatus {
  CANCELED = 'Canceled',
  COMPLETED = 'Completed',
  FAILED = 'Stopped',
  IN_PROGRESS = 'In Progress',
  PENDING = 'Pending',
}
